export default {
	"fileUploadComp": {
		"downloadZip": "Download package"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/components/FileUploadComp/FileUploadComp.js